import React, { useMemo } from 'react';
import { Badge } from '@mui/material';
import { useReactiveVar } from '@apollo/client';
import variables from '../variables';
import { MonitorHeart } from '@mui/icons-material';
import { statusCodes } from './StatusIndicator';

const HealthChecksActionIcon = () => {
  const parametersHealthChecks = useReactiveVar(variables.parametersHealthChecks);
  const failedHealthChecks = useMemo(
    () => (parametersHealthChecks?.length ? parametersHealthChecks.filter(param => param.status === statusCodes.ERROR).length : undefined),
    [parametersHealthChecks]
  );

  const warningHealthChecks = useMemo(
    () =>
      parametersHealthChecks?.length ? parametersHealthChecks.filter(param => param.status === statusCodes.WARNING).length : undefined,
    [parametersHealthChecks]
  );

  if (failedHealthChecks) {
    return (
      <Badge badgeContent={failedHealthChecks} color='error'>
        <MonitorHeart />
      </Badge>
    );
  }

  if (warningHealthChecks) {
    return (
      <Badge badgeContent={warningHealthChecks} color='warning'>
        <MonitorHeart />
      </Badge>
    );
  }

  return <MonitorHeart />;
};

export default HealthChecksActionIcon;
